import React from 'react';
import '../../styles/transport.css'; // Import Hero specific CSS
import '../../styles/Fonts.css'; // Import Hero specific CSS
import 'bootstrap/dist/css/bootstrap.min.css';
import '@fortawesome/fontawesome-free/css/all.min.css'; // Import Font Awesome

import serviceImage2 from '../../assets/cargo5.webp'; // Add your first service image
import serviceImage1 from '../../assets/transport.webp'; // Add your second service image

const TrackServices = () => {
  return (
    <>
      {/* Services Section */}
      <section id="about-track" className="py-5 transport-section">
      <div className="container">
        <div className="row py-5 main-service">
          {/* Left Text Section */}
          <div className="col-lg-6 col-sm-12 d-flex align-items-center text-center text-lg-start desc-container">
            <div className="mb-5 container-services">
              <button disabled className="custom-button mb-4 poppins-bold text-black">WHAT WE PROVIDE</button>
              <h1 className='poppins-bold text-dark fs-1'>Our Services</h1>
              <p className='poppins-regular transport-desc text-justify text-dark'>
              Track and Trace is a vital system that enables clients to monitor their shipments in real-time, offering full transparency throughout the delivery process. By providing up-to-date information and detailed remarks for each shipment status, such as "Order Placed,", "In Warehouse"," Depart at  Origin", "In Transit,", "Arrived at Destination", "Custom Clearance", "Out for Delivery," and "Delivered," clients are instantly notified of any changes, allowing them to stay informed and make timely decisions. This system enhances customer satisfaction by ensuring timely deliveries, improving communication, and reducing the risk of lost goods. 
              It is a crucial tool for businesses in industries like logistics, e-commerce, and retail, helping to streamline operations, boost efficiency, and build trust with customers.
              </p>
            </div>
          </div>

          {/* Right Stats Section */}
          <div className="col-lg-6 col-md-12 position-relative">
            <div className="overlap-container">
              <img src={serviceImage1} alt="Tracking system dashboard" className="img-fluid overlap-img1" />
              <img src={serviceImage2} alt="Package monitoring interface" className="img-fluid overlap-img2" />
            </div>
          </div>
        </div>
      </div>
    </section>

      {/* Include te other sections */}
      
    </>
  );
};

export default TrackServices;
